import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

console.log(
  '%c ',
  'background-image: url("https://cdn.discordapp.com/attachments/491302411898585088/929193425146871908/vrjmof.png"); padding: 10px 62px',
);
console.log('%cVR JMoF 2022!', 'font-size: 24px; color: #f1f1f1;');

createApp(App)
  .use(store)
  .use(router)
  .mount('#app');
